import React from 'react';
import { useLocation } from 'react-router-dom';

import { RetrievalType } from '@app/queryTyping';

import { RetrievalWizardLocationState } from '@app/widgets/user-retrieval/types';

import { RetrievalWizardStep } from './RetrievalWizardStep';
import { FieldLocator, WizardStepProps } from './types';
import { WizardStepWithHeader } from './WizardStepWithHeader';

export interface RetrievalWizardStepWithHeaderProps {
  readonly title: string;
  readonly description: string;
  readonly usernameTitle?: string;
  readonly usernameDescription?: string;
  readonly continueButtonTitle?: string;
  readonly stepLocators: readonly FieldLocator[];
  readonly wizardStepProps: WizardStepProps;
}

export const selectTextByRetrievalType = (
  retrievalType: RetrievalType, passwordTypeText: string, usernameTypeText?: string,
): string => (
  retrievalType === RetrievalType.USERNAME
    ? (usernameTypeText || passwordTypeText)
    : passwordTypeText
);

export const RetrievalWizardStepWithHeader: React.FC<RetrievalWizardStepWithHeaderProps> = ({
  title,
  description,
  usernameTitle,
  usernameDescription,
  continueButtonTitle,
  stepLocators,
  wizardStepProps,
}) => {
  const location = useLocation<RetrievalWizardLocationState>();
  const { retrievalType } = location.state;

  return (
    <WizardStepWithHeader
      title={selectTextByRetrievalType(retrievalType, title, usernameTitle)}
      description={selectTextByRetrievalType(retrievalType, description, usernameDescription)}
    >
      <RetrievalWizardStep
        continueButtonTitle={continueButtonTitle}
        stepLocators={stepLocators}
        wizardStepProps={wizardStepProps}
      />
    </WizardStepWithHeader>
  );
};
